/*eslint-disable max-len*/
import get from 'lodash/get';

import { UserType } from '../../core/users/users.types';
import store from '../../shared/Store';
import { ensureArray } from '../../utils/arrayUtils';
import { replaceValues } from '../../utils/stringUtils';
import { UserAction } from './components/types';

const { endpoints } = window.__DATA__;

export function getUserBadgeUri(badge: Record<string, any>, user: UserType): string {
  const badgeUrl = `${endpoints.document}/${store.eventId}/badges/users/${user.collection}/${user.privateKey}/badge.pdf`;
  if (badge?.templateUrl) {
    return replaceValues(badge.templateUrl, { url: badgeUrl, user });
  }
  return badgeUrl;
}

export function getUserTemplateDocument(documentTemplateId: string, user: UserType): string | null {
  if (!documentTemplateId) return null;
  return `${endpoints.document}/${store.eventId}/documents/generate-pdf/files/${documentTemplateId}/users/${user.privateKey}`;
}

export function hasUserPlaneTickets(
  actions: UserAction[],
  user: UserType,
  screen?: Record<string, any>,
): boolean {
  const hasAction = actions?.find(({ key }) => key === 'download-plane-tickets');
  if (!hasAction || !screen?.file?.field) return false;
  const fileArray = ensureArray(get(user, screen.file.field)).filter((f) => f.uri);
  if (!fileArray?.length) return false;
  return true;
}
